/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon20Regular = forwardRef('ScanFrameIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M17.75 5.5a3.25 3.25 0 0 0-3.25-3.25h-1.75a.75.75 0 0 0 0 1.5h1.75c.966 0 1.75.784 1.75 1.75v1.75a.75.75 0 0 0 1.5 0V5.5Z" }),
        React.createElement("path", { d: "M5.5 17.75a3.25 3.25 0 0 1-3.25-3.25v-1.75a.75.75 0 0 1 1.5 0v1.75c0 .966.784 1.75 1.75 1.75h1.75a.75.75 0 0 1 0 1.5H5.5Z" }),
        React.createElement("path", { d: "M14.5 17.75a3.25 3.25 0 0 0 3.25-3.25v-1.75a.75.75 0 0 0-1.5 0v1.75a1.75 1.75 0 0 1-1.75 1.75h-1.75a.75.75 0 0 0 0 1.5h1.75Z" }),
        React.createElement("path", { d: "M5.5 2.25A3.25 3.25 0 0 0 2.25 5.5v1.75a.75.75 0 0 0 1.5 0V5.5c0-.966.784-1.75 1.75-1.75h1.75a.75.75 0 0 0 0-1.5H5.5Z" })));
});
